/**
 * Anti-CSRF custom header (SEC-105 Option 1). Requests are Bearer-authenticated
 * (no cookies), so this is defence in depth; the console service allows it via CORS.
 * Send only on console API mutating requests — never on Cognito token fetches.
 */
export const CSRF_CUSTOM_HEADER_NAME = "X-Requested-With";
export const CSRF_CUSTOM_HEADER_VALUE = "XMLHttpRequest";

export const csrfCustomHeaderRecord = (): Record<string, string> => ({
  [CSRF_CUSTOM_HEADER_NAME]: CSRF_CUSTOM_HEADER_VALUE,
});

const MUTATING_METHODS = new Set(["POST", "PUT", "PATCH", "DELETE"]);

export const isMutatingHttpMethod = (method: string | undefined): boolean => {
  if (method == null || method === "") return false;
  return MUTATING_METHODS.has(method.toUpperCase());
};
